export default {"src":"/_next/static/media/instagram.6646c833.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};